module.exports = __webpack_public_path__ + "img/payment_success.fe73cdc8.svg";